import compose from 'lodash/fp/compose';
import isEmpty from 'lodash/fp/isEmpty';
import pickBy from 'lodash/fp/pickBy';

const isPropsNegative = compose(isEmpty, pickBy(Boolean));

export default isPropsNegative;
